import 'reflect-metadata';
import { AppGateway } from './routes';
import { LoadingProvider } from './hooks/useLoading';
import { MessageProvider } from './hooks/useMessage';
import { AnimationProvider } from './hooks/useControlledAnimation';
import { AppStateProvider } from './AppState';
import { ToastBar } from './pages/layout/ToastBar';
import { AuditCollector } from './AuditCollector';

export const mobileMargin = '15px';

function App() {
  return (
    <LoadingProvider>
      <MessageProvider>
        <AnimationProvider>
          <AppStateProvider>
            <AuditCollector>
              <ToastBar />
              <AppGateway />
            </AuditCollector>
          </AppStateProvider>
        </AnimationProvider>
      </MessageProvider>
    </LoadingProvider>
  );
}

export default App;
